<template>
  <div
    :class="{
      sidebar: true,
      '--short': !fullView,
      // '--hide': pagesTransition,
      ['--for-' + routeName]: true,
    }"
  >
    <div class="sidebar__logo">
      <router-link to="/">E<span class="_tail">ditor</span></router-link>
      <span class="_change-view" @click="toggleFullView()">{{
        fullView ? "-" : "+"
      }}</span>
    </div>
    <div v-if="isAuthenticated" class="sidebar__menu">
      <div
        v-for="(menuItem, num) in menuItemsPermitted"
        :key="num"
        :class="{
          sidebar__menu__item: true,
          '--active': menuItemInUrl(menuItem) || menuItem.active,
        }"
        @mouseover="showSubItems(menuItem)"
        @mouseout="hideSubItems(menuItem)"
      >
        <router-link v-if="!menuItem.subItems.length" :to="'/' + menuItem.url">
          {{ menuItem.title }}
        </router-link>
        <div v-else>
          {{ menuItem.title }}
          <span class="_plus" @click="showSubItems(menuItem)">+</span>
        </div>

        <div v-if="menuItem.subItems.length" class="sidebar__menu__subitems">
          <div
            v-for="(subItem, subItemIndex) in permittedPacks(
              menuItem.subItems,
              menuItem
            )"
            :key="subItemIndex"
            :class="{ '--active': subMenuItemInUrl(subItem) }"
          >
            <router-link
              v-if="subItem.url"
              :to="'/' + menuItem.url + '/' + subItem.url"
              class="_item"
            >
              {{ subItem.title }}
            </router-link>
            <div v-else class="_item">
              {{ subItem.title }}
              <div
                v-if="
                  subItem.moreItems != undefined && subItem.moreItems.length
                "
                class="sidebar__menu__subitems__moreitems"
              >
                <router-link
                  v-for="(m, mIndex) in permittedModules(subItem.moreItems)"
                  :key="mIndex"
                  :to="'/' + menuItem.url + '/' + m.url"
                  class="_final-item"
                >
                  {{ m.title }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isAuthenticated" class="sidebar__hotmenu">
      <ul class="no-style">
        <li v-if="this.isModulePermittted('lp')">
          <router-link :to="'/modules/115'">LP</router-link>
        </li>
        <li v-if="this.isModulePermittted('cd')">
          <router-link :to="'/modules/112'">CD</router-link>
        </li>
        <li v-if="this.isModulePermittted('acc_products')">
          <router-link :to="'/modules/117'">АК</router-link>
        </li>
      </ul>
    </div>
    <div v-if="isAuthenticated" class="sidebar__logout">
      <span @click="logout()" title="Выйти">
        <span class="_text">Выйти</span>
        <svg
          class="_icon"
          fill="none"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 16L21 12M21 12L17 8M21 12L7 12M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  components: {},
  data() {
    return {
      fullView: true,
      menuItems: [
        { title: "Модули", url: "modules", active: false, subItems: [] },
        { title: "Пользователи", url: "users", active: false, subItems: [] },
        { title: "Страницы", url: "pages", active: false, subItems: [] },
        { title: "Параметры", url: "options", active: false, subItems: [] },
        { title: "Отчеты", url: "reports", active: false, subItems: [] },
        { title: "SEO", url: "seo", active: false, subItems: [] },
        { title: "Корзины", url: "carts", active: false, subItems: [] },
        {
          title: "Сервисы",
          url: "services",
          active: false,
          subItems: [
            { title: "Сверка 1С", url: "compare_1c" },
            { title: "Списание 1С", url: "sales_1c" },
            { title: "Обновление цен", url: "prices" },
            { title: "Выгрузка Emails", url: "emails", onlyForUser: [40, 43] },
            {
              title: "Переоценка",
              url: "revaluation",
              onlyForUser: [40, 43, 47],
            },
            {
              title: "Новые поступления",
              url: "refresh",
              // onlyForUser: [40, 43],
            },
          ],
        },
      ],
    }
  },
  props: {
    // title: String,
  },
  created() {
    // window.addEventListener("scroll", this.handleScroll)
  },
  mounted() {
    this.menuItems[0].subItems = this.modules
    console.log("user ID: " + this.userId)
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.getUserRole() != ""
    },
    params() {
      return this.$store.getters.getParams()
    },
    routeTitle() {
      return this.pageTitles[this.$route.name]
    },
    routeName() {
      return this.$route.name
    },
    pagesTransition() {
      return this.$store.getters.getPagesTransition()
    },
    modules() {
      return this.$store.getters.getMenuModules()
    },
    userPermissions() {
      return this.$store.getters.getUserRolePermissions()
    },
    userId() {
      return this.$store.getters.getUserId()
    },
    menuItemsPermitted() {
      return this.menuItems.filter((item) => {
        return (
          this.userPermissions[item.url] != undefined &&
          this.userPermissions[item.url] != false
        )
      })
    },
  },
  methods: {
    menuItemInUrl(menuItem) {
      return this.$route.path.indexOf("/" + menuItem.url) !== -1
    },
    subMenuItemInUrl(menuItem) {
      return menuItem.url && this.$route.path.indexOf("/" + menuItem.url) !== -1
    },
    showSubItems(menuItem) {
      this.menuItems.forEach((item) => {
        item.active = false
      })
      menuItem.active = true
    },
    hideSubItems(menuItem) {
      if (this.routeName != menuItem.url) menuItem.active = false
    },
    handleScroll() {
      if (window.innerWidth <= 780) {
        if (window.scrollY > window.innerHeight) {
          this.scrolledDown = true
        } else {
          this.scrolledDown = false
        }
      }
    },
    toggleFullView() {
      this.fullView = !this.fullView
      this.$emit("viewchange")
    },
    isModulePermittted(moduleName) {
      if (this.userPermissions["modules"] == undefined) return false
      if (
        Array.isArray(this.userPermissions["modules"]) &&
        !this.userPermissions["modules"].includes(moduleName)
      )
        return false
      return true
    },
    permittedPacks(list, parent) {
      if (parent.url != "modules") {
        return list.filter((item) => {
          return (
            item.onlyForUser == undefined ||
            item.onlyForUser.includes(this.userId)
          )
        })
      } else
        return list.filter((item) => {
          return (
            this.userPermissions["packs"] == undefined ||
            this.userPermissions["packs"].includes(item.pack_id)
          )
        })
    },
    permittedModules(list) {
      return list.filter((item) => {
        return this.isModulePermittted(item.module_name)
      })
    },
    logout() {
      this.$store.dispatch("setUserRole", "")
      this.$store.dispatch("setUserId", "")
      localStorage.setItem("userId", "")
      localStorage.setItem("userRole", "")
      localStorage.setItem("userRoleToken", "")
      this.$router.push("/login")
    },
  },
}
</script>
